import {
  Anchor,
  Archive,
  Armchair,
  ArrowUpDown,
  Award,
  BadgeDollarSign,
  BookOpenCheck,
  Box,
  BriefcaseMedical,
  Calendar1,
  CalendarCheck,
  CalendarX,
  ChartGantt,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  CircleMinus,
  ClipboardList,
  Clock4,
  Coins,
  Contact,
  CopyPlus,
  DoorClosed,
  DoorOpen,
  Download,
  Ellipsis,
  FileBadge,
  FileDiff,
  Files,
  Flag,
  Forklift,
  GitCompareArrows,
  HandCoins,
  HandHelping,
  HardHat,
  Hotel,
  House,
  IdCardLanyard,
  Info,
  ListClock,
  LogOut,
  MoveVertical,
  PackageCheck,
  Pencil,
  Percent,
  Phone,
  PlugZap,
  Plus,
  Receipt,
  ScrollText,
  Search,
  Send,
  Smartphone,
  Trash2,
  TriangleAlert,
  Truck,
  UserGroup,
  UserStar,
  Warehouse,
  type LucideIcon,
} from 'lucide-react';

/**
 * The app's icon set (CB-CONV §7, v1.83): one Lucide icon per concept, chosen by the operator on
 * 2026-10-24, and used wherever that concept appears — the side rail, a line type, a fact chip, a
 * button. Take an icon from here by what it means, never from `lucide-react` directly, so a venue
 * is the same hotel on the rail, on a quote line and on a job.
 *
 * Several are chosen ahead of the screens that will use them (the job, crew and venue designs in
 * `docs/designs`); they wait here so those screens draw the operator's choice, not a new one.
 * A concept missing from this list needs the operator's pick before it is drawn.
 */
export const icons = {
  // People and places
  client: Contact,
  venue: Hotel,
  crew: UserGroup,
  accountManager: UserStar,
  phone: Phone,
  emergencyContact: BriefcaseMedical,

  // Work. The job keeps today's icon: the operator has not picked one yet.
  home: House,
  quote: ScrollText,
  job: ClipboardList,
  invoice: Receipt,
  shift: CalendarCheck,
  roster: ChartGantt,
  runSheet: ListClock,
  variation: FileDiff,

  // Lines and money
  gear: Box,
  service: HandHelping,
  transport: Truck,
  pricing: BadgeDollarSign,
  value: Coins,
  margin: Percent,
  payRates: HandCoins,

  // Venue facts
  rooms: DoorClosed,
  seats: Armchair,
  power: PlugZap,
  rigging: Anchor,
  height: MoveVertical,
  lift: ArrowUpDown,
  dock: Forklift,
  accessHours: Clock4,
  doors: DoorOpen,
  showEnd: Flag,
  instructions: Info,
  gotIt: CheckCheck,

  // Where gear comes from. The venue's own gear is `venue`; the client's is `client`.
  depot: Warehouse,
  oursAtVenue: PackageCheck,
  crossHire: GitCompareArrows,

  // A crew member's record
  offerShift: Send,
  heldDay: Calendar1,
  unavailable: CalendarX,
  skills: Award,
  tickets: IdCardLanyard,
  inductions: BookOpenCheck,
  appAccess: Smartphone,

  // Safety and settings
  swms: HardHat,
  insurance: FileBadge,
  documents: Files,
  problem: TriangleAlert,
  signOut: LogOut,

  // Actions
  add: Plus,
  edit: Pencil,
  remove: Trash2,
  retire: Archive,
  search: Search,
  download: Download,
  added: CircleCheck,
  oneFewer: CircleMinus,
  duplicate: CopyPlus,
  more: Ellipsis,
  moveUp: ChevronUp,
  moveDown: ChevronDown,
  previous: ChevronLeft,
  next: ChevronRight,
} as const satisfies Record<string, LucideIcon>;
